import { API } from "../api";

const PayAPI = process.env.REACT_APP_API_PAY;

export const PaymentOptions = API(PayAPI, "GET", "/pay/options");
export const PaymentCheckoutURL = `${PayAPI}/pay/checkout`;
export const PaymentPortalURL = `${PayAPI}/pay/portal`;
